<template>
    <MuvalModal
        v-model="user.tenantModalStatus"
        modalSize="md:w-2/3"
    >
        <template #header>
            <div class="flex text-muval-gray-1">Select tenant to continue</div>
        </template>
        <div class="grid gap-4">
            <div
                v-for="tenant in user.data.tenants"
                :key="tenant.id"
                class="card flex h-24 w-full cursor-pointer p-4 hover:bg-gray-50"
                @click="selectTenant(tenant.id)"
            >
                <div
                    :style="`background-image: url('${tenant.logo}'); background-size: contain;`"
                    class="mr-2 h-auto w-32 flex-none overflow-hidden bg-center bg-no-repeat"
                    :alt="`Logo of ${tenant.name}`"
                ></div>
                <div class="flex w-full flex-row items-center justify-between pl-4">
                    <div>
                        <div class="text-base font-medium">{{ tenant.name }}</div>
                        <div class="text-sm text-muval-gray-3">{{ tenant.slug }}</div>
                        <div class="text-sm text-muval-gray-3">#{{ tenant.id }}</div>
                    </div>
                    <MuvalButton>Select</MuvalButton>
                </div>
            </div>
        </div>
    </MuvalModal>
</template>

<script setup>
import MuvalModal from '@components/modal/MuvalModal.vue';
import { useQueryClient } from '@tanstack/vue-query';

const user = useUserStore();
const router = useRouter();

const keys = useMagicKeys({
    passive: false,
    onEventFired(e) {
        if (e.key === 'e' && (e.ctrlKey || e.metaKey)) {
            e.preventDefault();
        }
    },
});

const keyCtrlE = keys['Ctrl+E'];
const keyCmdE = keys['Cmd+E'];
const keyEscape = keys['escape'];

const tenantModal = {
    open: () => {
        user.showTenantModal();
    },
    close: () => {
        user.hideTenantModal();
    },
    toggle: () => {
        user.toggleTenantModal();
    },
};

const queryClient = useQueryClient();

const selectTenant = async (tenantId) => {
    await user.setTenant(tenantId);

    tenantModal.close();

    if (router.currentRoute.value.name === 'Dashboard') {
        // If already on dashboard, manually refetch the query
        await queryClient.invalidateQueries(['dashboard']);
    } else {
        // Otherwise, navigate to dashboard
        router.push({ name: 'Dashboard' });
    }
};

whenever(keyCtrlE, tenantModal.toggle);
whenever(keyCmdE, tenantModal.toggle);
whenever(keyEscape, tenantModal.close);
</script>
